import { LaneDirection } from '@kinetic-ui/data-layer';
import { useDynamicDocumentationLink } from 'components/layouts';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LocationFormContext } from '../../context';
import { LaneList } from './LaneList';
import { NewLaneForm } from './NewLaneForm';
import useLaneStyles from './styles';

export const Lanes = () => {
  const { t } = useTranslation(['locations', 'common']);
  const classes = useLaneStyles();
  const { values } = useContext(LocationFormContext);

  useDynamicDocumentationLink({ link: 'LOCATIONS_ADD_LANES' });

  const lanes = useMemo(() => values?.lanes ?? [], [values?.lanes]);

  const approachLanes = useMemo(
    () => lanes.filter((lane) => lane.laneDirection === LaneDirection.Approach),
    [lanes]
  );
  const departureLanes = useMemo(
    () => lanes.filter((lane) => lane.laneDirection === LaneDirection.Departure),
    [lanes]
  );

  return (
    <>
      <NewLaneForm />
      <div className={classes.lanesContainer}>
        <LaneList lanes={approachLanes} title={t('common:approachLanes')} />
        <LaneList lanes={departureLanes} title={t('common:departureLanes')} />
      </div>
    </>
  );
};
